import BezierEasing from 'bezier-easing';

class EasingController {

	constructor() {
		this.curves = {
			easeIn:	[0.490, 0.025, 0.650, 0.650],
			easeOut: [0.280, 0.440, 0.490, 1.000],
			easeInOut: [0.490, 0.025, 0.490, 1.000],
			easeInSoft: [0.490, 0.025, 0.685, 1.000],
			easeOutSoft: [0.280, 0.000, 0.490, 1.000],
			easeInOutSoft: [0.720, 0.000, 0.280, 1.000],
			easeOutJim:	[0.420, 0.000, 0.002, 1.000],
			easeOutJimFast: [0.000, 0.000, 0.002, 1.000]
		};
	}

	ease(curve) {
		if (curve) {
			return BezierEasing(...curve);
		}
		return null;
	}

}

export default new EasingController();
